// NOTE all the paths MUST be relative. DO NOT START THEM WITH '/'

export const ROUTE_NAMES = {
  INVESTORS_POSITIONS: 'investors-positions'
}

const ROUTES = {
  [ROUTE_NAMES.INVESTORS_POSITIONS]: {
    name: ROUTE_NAMES.INVESTORS_POSITIONS,
    path: 'investors/positions'
  }
}

export default [
  {
    name: ROUTES[ROUTE_NAMES.INVESTORS_POSITIONS].name,
    path: ROUTES[ROUTE_NAMES.INVESTORS_POSITIONS].path,
    component: (resolve) => require(['./views/positions.vue'], resolve)
  }
]
